"use client";

import { RelatedSymbol } from "@/features/analysis/related-symbol/services/related-symbols";
import { useUpdateQuery } from "@/hooks/use-update-query";

export const RelevanceItem = ({
  index,
  symbolData,
}: {
  index: number;
  symbolData: RelatedSymbol;
}) => {
  const { updateQuery } = useUpdateQuery();
  return (
    <>
      <div className="relative flex h-6 w-6 flex-none items-center justify-center bg-white">
        <div className="h-2 w-2 rounded-full bg-zinc-100" />
      </div>
      <button
        className="py-0.5 text-start text-xs leading-5 text-gray-500"
        onClick={() =>
          updateQuery({ name: "relevanceIndex", value: `${index}` })
        }
        aria-label={`view ${symbolData.symbol} details`}
      >
        <span className="font-medium text-gray-900">{symbolData.symbol}</span>{" "}
        {symbolData.companyName}
      </button>
    </>
  );
};
